import { defineAction } from "redux-define";
import {
    ERROR, LOADING,
    SUCCESS,
    TheApp
} from "../../constants/stateConstants";

export const checks = defineAction("checks", [LOADING, ERROR, SUCCESS], TheApp);
export const GET = defineAction("GET", [LOADING, ERROR, SUCCESS], checks);
export const CREATE = defineAction("CREATE", [LOADING, ERROR, SUCCESS], checks);
export const UPDATE = defineAction("UPDATE", [LOADING, ERROR, SUCCESS], checks);
export const DELETE = defineAction("DELETE", [LOADING, ERROR, SUCCESS], checks);
